import Vue from 'node_modules/vue'
import App from './App'
import router from './router'

import BootstrapVue from 'node_modules/bootstrap-vue'

import globals from './globals'
import mdn from './mdn'
import Popper from 'node_modules/popper.js'
import axios from 'node_modules/axios'
import Notifications from 'node_modules/vue-notification'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faHeartbeat, faUserTie, faUsers, faHandPeace, faComment, faProjectDiagram, faChartPie, faTabletAlt, faHandSpock, faSync } from 'node_modules/@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from 'node_modules/@fortawesome/vue-fontawesome'

// Required to enable animations on dropdowns/tooltips/popovers
Popper.Defaults.modifiers.computeStyle.gpuAcceleration = false

Vue.config.productionTip = false

Vue.use(BootstrapVue)
Vue.use(Notifications)
Vue.prototype.$http = axios

// FontAwesome:
library.add(faHeartbeat, faUserTie, faUsers, faHandPeace, faComment, faProjectDiagram, faChartPie, faTabletAlt, faHandSpock, faSync)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.config.productionTip = false

// Global RTL flag
Vue.mixin({
  data: globals
})

// myDataNet Mixin für die notwendigen Library Functions die alle Vue-Components haben wollen
Vue.mixin({
  data: mdn
})

// Bus für die Kommunikation der Vue Components untereinander
export const serverBus = new Vue()

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
